export default __webpack_public_path__ + "static/media/mmr-port.36e161e0.svg";